import { render } from "./globalStat.vue?vue&type=template&id=73e5a7f4&scoped=true"
import script from "./globalStat.vue?vue&type=script&lang=js"
export * from "./globalStat.vue?vue&type=script&lang=js"

import "./globalStat.vue?vue&type=style&index=0&id=73e5a7f4&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e5a7f4"]])

export default __exports__